import React from "react";
import { Menu, MenuItem } from "@mui/material";
import i18n from "i18";

/**
 * The Edit / Delete menu of the groups of accounts. The page renders one of them for all groups and
 * passes the group whose "..." was clicked, so a choice never reaches another group.
 */
class GroupActionsMenu extends React.Component {
  render() {
    const { anchorEl, group, onClose, onEdit, onDelete } = this.props;

    return (
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl) && Boolean(group)}
        onClose={onClose}
        onClick={onClose}
        PaperProps={{
          style: {
            backgroundColor: "var(--hedear-bg)",
          },
        }}>
        <MenuItem onClick={() => onEdit(group)} sx={{ color: "var(--text-color)" }}>
          {i18n.t("edit")}
        </MenuItem>
        <MenuItem onClick={() => onDelete(group)} sx={{ color: "var(--text-color)" }}>
          {i18n.t("delete")}
        </MenuItem>
      </Menu>
    );
  }
}

export default GroupActionsMenu;
